module.exports = __webpack_public_path__ + "static/media/logo-servizi-bibliotecari-nero.66045df6.png";